export default {
  supplierbenefits: {
    subtitle: "مزايا الموردين",

    title1: "لماذا يختار الموردون",
    title2: "MAHAL",

    desc:
      "تم تصميم MAHAL لمساعدة الموردين على النمو بشكل أسرع، والبيع بذكاء، وبناء شراكات طويلة الأمد مع المطاعم.",

    b1_title: "الوصول المباشر إلى المطاعم",
    b1_desc:
      "تواصل مباشرة مع المطاعم والشركات الغذائية الموثوقة بدون وسطاء.",

    b2_title: "طلبات بالجملة ومتكررة",
    b2_desc:
      "احصل على طلبات ثابتة ومتكررة تساعد في استقرار مبيعاتك اليومية.",

    b3_title: "مدفوعات آمنة وفي الوقت المناسب",
    b3_desc:
      "أسعار شفافة ودورات دفع موثوقة يمكنك الاعتماد عليها.",

    b4_title: "دعم الخدمات اللوجستية والتوصيل",
    b4_desc:
      "احصل على دعم في تنسيق عمليات التوصيل وجدولة الإمدادات.",

    b5_title: "تحليلات لنمو الأعمال",
    b5_desc:
      "تابع اتجاهات الطلب وإدارة المخزون والنمو باستخدام البيانات.",

    b6_title: "شراكات طويلة الأمد",
    b6_desc:
      "ابنِ علاقات موثوقة مع المطاعم لتحقيق نمو مستدام.",

    cta: "ابدأ البيع على MAHAL",
  },
};